import React from 'react';
import styles from '../estudio_amsterdam_ink/estudio_amsterdam_ink.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import TattooIcon from '../../icons/tattooIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';

const Estudio_amsterdam_ink: React.FC = () => {

    return (
        <div className={styles.estudio_amsterdam_ink}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <img className={styles["img-perfil"]} src={Perfil} />
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            href="https://wa.me/5519997384163?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                            title="WHATSAPP"
                            icon={<WhatsappIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/fatyLvdgWNE2uE3z8"
                            title="LOCALIZAÇÃO"
                            icon={<MapsIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://www.instagram.com/estudio_amsterdam_ink?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="INSTAGRAM"
                            spaceBetween={true}
                            icon={<InstagramIcon height="32" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            linkInterno={true}
                            href="/estudio_amsterdam_ink/galeria"
                            title="GALERIA"
                            icon={<TattooIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Estudio_amsterdam_ink;
